import {useWorkspace} from '../hooks/useWorkspace';
import ChatWindow from '../components/ChatWindow';
import {PlanCard, TaskList} from '../components/WorkComponents';
import HqAttentionStrip from '../components/HqAttentionStrip';
import HqSearchCard from '../components/HqSearchCard';
import HqActivityFeed from '../components/HqActivityFeed';
import {getUsageSummary} from '../services/aoMeter';

export default function Headquarters() {
  const state = useWorkspace();

  // HQ chat lead: Business Manager bot (Alex)
  const lead = state.bots.find((bot) => bot.slug === 'business-manager')
    || state.bots.find((bot) => bot.id === 'bot_bm')
    || state.bots.find((bot) => bot.isLead && bot.enabled);
  const usage = getUsageSummary(state);

  const openTasks = (state.tasks || []).filter((task) => task.status !== 'done');
  const activePlans = (state.plans || []);
  const activeBots = (state.bots || []).filter((bot) => bot.enabled);

  return (
    <div className="page">
      <header className="page-header hero-header">
        <div>
          <span className="eyebrow">Headquarters</span>
          <h1>Good morning, {(state.session?.user?.name || 'there').split(' ')[0]}.</h1>
          <p>Your business command center: live activity, unified recall, and AI workforce.</p>
        </div>
        <div className="date-card">
          <small>Workforce pulse</small>
          <b>{activeBots.length} bots active</b>
          <span>{openTasks.length} open priorities</span>
        </div>
      </header>

      {/* Attention Needed Strip (plan-limit alerts, overdue tasks, pending approvals) */}
      <HqAttentionStrip state={state} usage={usage} />

      {/* High-level status overview */}
      <div className="stats-grid">
        <article>
          <small>Open tasks</small>
          <b>{openTasks.length}</b>
          <span>{openTasks.filter((t) => t.status === 'review' || t.status === 'doing').length} in progress or review</span>
        </article>
        <article>
          <small>Active plans</small>
          <b>{activePlans.length}</b>
          <span>Across Finance, Ads, and Website</span>
        </article>
        <article>
          <small>Agent Operations</small>
          <b>{usage.used} / {usage.allowance}</b>
          <span>{usage.remaining} AO left on {usage.planName}</span>
        </article>
      </div>

      {/* Split view: live aggregation dashboard + docked Business Manager chat */}
      <div className="hq-grid">
        <section className="hq-main-pane">
          {/* Universal recall: persistent search card */}
          <HqSearchCard state={state} />

          {/* Priority Tasks */}
          <div className="section-heading">
            <div>
              <span className="eyebrow">Priority work</span>
              <h2>Latest tasks</h2>
            </div>
          </div>
          <TaskList tasks={openTasks.slice(0, 4)} plans={state.plans} />

          {/* Active Decisions & Plans */}
          <div className="section-heading top-gap">
            <div>
              <span className="eyebrow">Plans &amp; Decisions</span>
              <h2>Active briefs</h2>
            </div>
          </div>
          <div className="card-grid">
            {activePlans.slice(0, 4).map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                bot={state.bots.find((bot) => bot.id === plan.botId)}
              />
            ))}
          </div>

          {/* Activity feed across modules */}
          <HqActivityFeed activity={state.activity || []} />
        </section>

        {/* Docked Business Manager Chat (never full-screen takeover) */}
        <aside className="hq-docked-aside">
          <ChatWindow
            module="headquarters"
            lead={lead}
            messages={state.messages?.headquarters || []}
            planLabel="Save decision as Plan"
            onPlan={() => {}}
          />
        </aside>
      </div>
    </div>
  );
}
